<template>
  <div class="content-warpper">
    <div class="warpper-title flex align-center justify-between">
      <div>
        <i class="iconfont iconjigou2"></i>
        协调中心详情
      </div>
      <div v-if="!isExamine">
<!--        <el-button type="primary">上传盖章</el-button>-->
        <el-button type="danger" v-if="orgDetail" @click="closeItem(orgDetail.status === 1?0:1)">{{orgDetail.status === 1?'冻结机构':'解除冻结'}}</el-button>
      </div>
    </div>
    <div class="padding-sm flex align-start justify-between detail-warpper" v-if="orgDetail">
      <div class="flex-sub info-warpper">
        <h2 class="flex align-center detail-title margin-bottom-xs"><span>{{orgDetail.org_type_txt}}信息</span></h2>
        <el-row class="org-info">
          <el-col :span="4"><div class="label-box">机构名称</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_name }}</div></el-col>
          <el-col :span="4"><div class="label-box">授权编号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_num }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构组织代码</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.org_code }} </div></el-col>
          <el-col :span="4"><div class="label-box">机构所在地</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.regionArr }}{{orgDetail.address}}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人姓名</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.username }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人手机号</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.phone }}</div></el-col>
          <el-col :span="4"><div class="label-box">联系人邮箱</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.email }}</div></el-col>
          <el-col :span="4"><div class="label-box">到期时间</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.due_date }}</div></el-col>
          <el-col :span="4"><div class="label-box">等级</div></el-col>
          <el-col :span="8"><div class="info-box">
            <span v-if="orgDetail.level_id  === 0">全国</span>
            <span v-if="orgDetail.level_id  === 1">省级</span>
            <span v-if="orgDetail.level_id  === 2">地区</span>
          </div></el-col>
          <el-col :span="4"><div class="label-box">隶属协调中心</div></el-col>
          <el-col :span="8"><div class="info-box">{{ orgDetail.xtzx_name?orgDetail.xtzx_name:'项目办' }}</div></el-col>

        </el-row>
        <div class="flex align-start margin-tb" v-if="orgDetail.longitude">
          <h3 class="margin-right">地理位置</h3>
          <div class="flex-sub">
            <div id="map-container" style="width:100%;height:300px;"/>

          </div>
        </div>

        <div v-if="orgDetail.desc_past">
          <h3 class="detail-small-title margin-tb-sm">
            <span v-if="orgDetail.org_type === 3">二、发展用人单位的计划</span>
            <span v-if="orgDetail.org_type === 4">二、考试组织</span>
            <span v-if="orgDetail.org_type === 5">二、高校发展规划</span>
          </h3>
          <div class="quest-item">
            <p class="quest-title">
              <span v-if="orgDetail.org_type === 3">1.	正在或曾经从事的服务于某类群体的项目介绍，如：协会会员服务、俱乐部会员服务、招聘服务等。</span>
              <span v-if="orgDetail.org_type === 4">1.	请简述正在或组织过的考试，包括：考试的名称、规模、运营该种考试的时间、相应的考务团队、使用的考试系统等；</span>
              <span v-if="orgDetail.org_type === 5">1.	正在或曾经的校企合作项目介绍，如：专业共建、联合科研等。</span>
            </p>
            <div class="anwer-info">{{ orgDetail.desc_past }}</div>
          </div>
          <div class="quest-item">
            <p class="quest-title">
              <span v-if="orgDetail.org_type === 3">2.	研学旅行指导师项目实习和招聘单位的发展规划。</span>
              <span v-if="orgDetail.org_type === 4">2.	请简述对研学旅行指导师考试的准备情况，包括：人员、经费、机构、考场渠道、与考场签约计划或签约情况等。</span>
              <span v-if="orgDetail.org_type === 5">2.	研学旅行指导师项目高校发展规划，包括：销售渠道、销售团队、渠道合作规划、高校的合作规划等。</span>
            </p>
            <div class="anwer-info">{{ orgDetail.desc_plan }}</div>
          </div>
        </div>

        <div v-if="orgDetail.remark">
          <h3 class="detail-small-title">三、其他信息</h3>
          <div class="quest-item">
            <p class="quest-title">备注信息</p>
            <div class="anwer-info">{{ orgDetail.remark }}</div>
          </div>
        </div>
        <div class="margin-tb flex align-center justify-around" v-if="isExamine">
          <nianExamine :org-type="6" :xtzx_id="orgDetail.xtzx_id"/>
        </div>
      </div>
      <time-list :id="id" :type="6"/>


    </div>
  </div>
</template>
<script>
import loadBMap from "@/tools/utils";
import {orgOne, orgSet, shenheDetail} from "@/api/projectOffice";
import {CodeToText} from "element-china-area-data";
import timeList from "@/views/projectOffice/page/conponents/timeList";
import nianExamine from "@/views/projectOffice/page/conponents/nianExamine";
export default {
  name: "organizationDetail",
  data() {
    return {
      id: '',
      year: 2021,
      yearOptions: [
        {label: '2021年', value: 2021},
        {label: '2022年', value: 2022},
        {label: '2023年', value: 2023},
        {label: '2024年', value: 2024}
      ],
      orgDetail: null,

      isExamine:false
    }
  },
  components:{
    timeList,
    nianExamine
  },
  created() {
    this.id = Number(this.$route.query.id)
    if(this.$route.query.nian && (Number(this.$route.query.shenType) === 0 || Number(this.$route.query.shenType) === 1)) this.isExamine = true
    this.$emit(
        "setIndex",
        this.isExamine?'/projectOffice/annualReview':'/projectOffice/organization',
        "当前位置：机构管理 > <span>协调中心详情</span> ",
        true
    );
    this.getDetail();
  },
  async mounted() {
    await loadBMap("McBWgFElxpnhhnO5kHHthQyG2KRsHLZS"); //加载引入BMap
  },
  methods: {
    closeItem(state) {
      this.$confirm(state === 0?"确定要冻结该机构吗？":"确定要解除该机构的冻结吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureClose(state);
      });
    },
    async sureClose(state) {
      let _state = await orgSet(this.$route.query.id,6, state);
        this.getDetail();
      this.$message.success(_state.msg);
    },


    async getDetail() {
      let _data = this.$route.query.nian?await shenheDetail(this.$route.query.shenId,6) :await orgOne(this.id,6)
      let _arr = _data.data.region_text.split(',')
      _data.data.regionArr = CodeToText[_arr[0]] +  CodeToText[_arr[1]] +  CodeToText[_arr[2]]
      _data.data.latitude = Number(_data.data.latitude)
      _data.data.longitude = Number(_data.data.longitude)
      this.orgDetail = _data.data
      if(this.orgDetail.longitude){
        this.$nextTick(()=>{
          this.initMap();
        })
      }

    },
    //  地图部分
    initMap() {
      var that = this;
      // 1、挂载地图
      this.map = new BMap.Map("map-container", {enableMapClick: false});
      var point = new BMap.Point(116.403963, 39.913261);
      this.map.centerAndZoom(point, 16);
      // this.map.enableScrollWheelZoom(true);

      // 3、设置图像标注并绑定拖拽标注结束后事件
      this.mk = new BMap.Marker(point, {enableDragging: true});
      this.map.addOverlay(this.mk);
      // this.mk.addEventListener("dragend", function (e) {
      //   that.getAddrByPoint(e.point);
      // });
      // 4、添加（右上角）平移缩放控件
      this.map.addControl(
          new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            type: BMAP_NAVIGATION_CONTROL_SMALL
          })
      );
      // 5、添加（左下角）定位控件
      var geolocationControl = new BMap.GeolocationControl({
        anchor: BMAP_ANCHOR_BOTTOM_LEFT
      });
      geolocationControl.addEventListener("locationSuccess", function (e) {
        that.getAddrByPoint(e.point);
      });
      geolocationControl.addEventListener("locationError", function (e) {
        alert(e.message);
      });
      this.map.addControl(geolocationControl);
      // 6、浏览器定位
      // this.geolocation()
      // 7、绑定点击地图任意点事件
      // this.map.addEventListener('click', function (e) {
      //   that.getAddrByPoint(e.point)
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-warpper {
  .info-warpper {
    .detail-title {
      height: 60px;

      span {
        display: block;
        line-height: 29px;
        font-size: 22px;
        padding-left: 15px;
        position: relative;

        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: '';
          width: 8px;
          height: 29px;
          background-color: #009688;
          border-radius: 4px;
        }
      }
    }

    .detail-num {
      height: 50px;
      padding: 0 20px;
      background-color: #ffffff;
      border: solid 1px #dae6f1;
      font-size: 18px;
      margin-right: 20px;

      span {
        margin-right: 20px;

      }

      b {
        i {
          color: #009688;
        }
      }

      .link-text {
        margin-left: 10px;
        color: #009688;
        font-size: 18px;
      }
    }


    .org-info {
      .label-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #eef7ff;
        border: solid 1px #dae6f1;
      }

      .info-box {
        display: flex;
        align-items: center;
        height: 48px;
        padding-left: 20px;
        background: #fff;
        border: solid 1px #dae6f1;
      }
    }

    .detail-small-title {
      line-height: 30px;
      font-size: 18px;
    }

    .quest-item {
      margin: 10px 0 20px;
      padding-left: 32px;

      .quest-title {
        margin-bottom: 10px;
      }

      .anwer-info {
        width: 100%;
        padding: 15px;
        background-color: #f1f1f1;
        border-radius: 4px;
      }
    }
  }

  .time-list {

    margin-left: 30px;
    width: 340px;
    padding: 30px;
    background-color: #ffffff;
    border: solid 1px #dae6f1;

    p {
      width: 90px;
      height: 20px;
      margin: 0 auto 30px;
      font-size: 18px;
      font-weight: bold;
      line-height: 30px;
      position: relative;
      text-align: center;

      &:before {
        position: absolute;
        left: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }

      &:after {
        position: absolute;
        right: -20px;
        top: 14px;
        content: '';
        width: 20px;
        height: 2px;
        background-color: #009688;
      }
    }
  }

}

</style>